var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ld-nomore"},[_c('van-divider',{style:({color:_vm.fontColor})},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }